import React from "react";
import downArrow from "../assets/downArrow.png"; // Replace with the actual path to your image
import webApp1 from "../assets/webApp1.png"; // Replace with the actual path to your image
import webApp2 from "../assets/webApp2.png"; // Replace with the actual path to your image
import webApp3 from "../assets/webApp3.png"; // Replace with the actual path to your image

const HowItWorks = () => {
  return (
    <section className="lg:bg-black bg-[#191919] text-white py-10 px-4 sm:px-6 lg:px-8 font-inter">
      {/* Top Description */}
      <div className="lg:bg-black bg-[#191919] text-white py-12 px-4">
        <div className="max-w-6xl mx-auto">
          {/* Title */}
          <h1
            className="text-3xl md:text-6xl lg:text-6xl font-monument font-extrabold text-primary text-center"
            style={{ fontWeight: 800 }}
          >
            BEFORE TRADING
          </h1>
          {/* Down Arrow */}
          <div className="flex justify-center my-4">
            <img src={downArrow} alt="Arrow Down" className="h-6 md:h-8" />
          </div>

          {/* Trading Service Note */}
          <div className="border border-primary rounded-full p-3 text-center text-primary text-sm mb-6 max-w-md mx-auto">
            *Our Trading Service helps you earn money by trading safely
          </div>

          {/* Steps Container */}
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-4 items-stretch justify-between">
  {/* Step 1 */}
  <div className="flex flex-col items-center text-center max-w-sm flex-1">
    <div className="border-2 border-primary rounded-3xl p-2 w-full">
      <img
        src={webApp1}
        alt="EA FIFA Web App"
        className="w-full h-64 object-cover rounded-2xl" // Consistent size
      />
    </div>
    <p className="text-lg mt-4">
       <span className="text-primary">EA's FIFA Web App</span> and<br />
      log in with your EA account.
    </p>
  </div>

  {/* Down Arrow - Mobile Only */}
  <div className="flex lg:hidden justify-center my-4">
    <img src={downArrow} alt="Arrow Down" className="h-6 md:h-8" />
  </div>

  {/* Step 2 */}
  <div className="flex flex-col items-center text-center max-w-sm flex-1">
    <div className="border-2 border-primary rounded-3xl p-2 w-full">
      <img
        src={webApp2}
        alt="Transfer Market"
        className="w-full h-64 object-cover rounded-2xl" // Consistent size
      />
    </div>
    <p className="text-lg mt-4">
      Click on <span className="text-primary">Transfers</span> once you're in.
    </p>
  </div>

  {/* Down Arrow - Mobile Only */}
  <div className="flex lg:hidden justify-center my-4">
    <img src={downArrow} alt="Arrow Down" className="h-6 md:h-8" />
  </div>

  {/* Step 3 */}
  <div className="flex flex-col items-center text-center max-w-sm flex-1">
    <div className="border-2 border-primary rounded-3xl p-2 w-full">
      <img
        src={webApp3}
        alt="Transfer List"
        className="w-full h-64 object-cover rounded-2xl" // Consistent size
      />
    </div>
    <p className="text-lg mt-4">
      If you <span className="text-primary">see</span> the <span className="text-primary">cannot access the transfer market</span>,<br />
      you are <span className="text-primary">ineligible to</span> make a purchase.
    </p>
  </div>
</div>


          {/* Bottom Note */}
          <div className="border border-primary rounded-full px-6 py-2 text-center text-primary text-sm mt-8 max-w-md mx-auto">
            *You only pay for the trading service, not for the coins
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
